// extracted by mini-css-extract-plugin
export default {"pos-center":"LoadingSpinner_pos-center__ZID3Z","loader":"LoadingSpinner_loader__Y0bBk","spin":"LoadingSpinner_spin__6rBbR"};